import React, { useState, useEffect } from 'react';

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [key, setKey] = useState('');
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);

  // המפתח הסודי - אפשר לשנות אותו
  const ADMIN_KEY = 'hamador2026admin';

  const handleLogin = (e) => {
    e.preventDefault();
    if (key === ADMIN_KEY) {
      setIsAuthenticated(true);
      setError('');
      fetchOrders();
    } else {
      setError('מפתח שגוי');
    }
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://us-central1-hamador-6119e.cloudfunctions.net/getOrders');
      if (response.ok) {
        const data = await response.json();
        console.log('Orders received from server:', data.orders);
        if (data.orders && data.orders.length > 0) {
          console.log('First order timestamp:', data.orders[0].timestamp);
        }
        setOrders(data.orders || []);
      } else {
        setError('שגיאה בטעינת הנתונים');
      }
    } catch (err) {
      setError('שגיאה בחיבור לשרת');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'לא זמין';
    
    console.log('Timestamp received:', timestamp, 'Type:', typeof timestamp);
    
    let date;
    
    // בדיקה אם זה Firestore Timestamp
    if (timestamp.seconds) {
      date = new Date(timestamp.seconds * 1000);
    }
    // בדיקה אם זה Date object
    else if (timestamp instanceof Date) {
      date = timestamp;
    }
    // בדיקה אם זה string או number
    else if (typeof timestamp === 'string' || typeof timestamp === 'number') {
      date = new Date(timestamp);
    }
    // אם זה null או undefined
    else {
      return 'לא זמין';
    }
    
    // בדיקה אם התאריך תקין
    if (isNaN(date.getTime())) {
      return 'תאריך לא תקין';
    }
    
    return date.toLocaleString('he-IL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
        <div className="bg-gray-800 rounded-xl p-8 w-full max-w-md">
          <h1 className="text-2xl font-black text-center mb-6" style={{color:'var(--brand-accent)'}}>
            🔐 דף ניהול
          </h1>
          
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                מפתח גישה
              </label>
              <input
                type="password"
                value={key}
                onChange={(e) => setKey(e.target.value)}
                className="w-full px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-green-500"
                placeholder="הכנס מפתח גישה"
                required
              />
            </div>
            
            <button
              type="submit"
              className="w-full py-3 px-4 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg transition-colors"
            >
              התחבר
            </button>
            
            {error && (
              <div className="text-red-400 text-sm text-center">{error}</div>
            )}
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 p-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-3xl font-black" style={{color:'var(--brand-accent)'}}>
            📊 דף ניהול - הזמנות
          </h1>
          <button
            onClick={() => setIsAuthenticated(false)}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg"
          >
            התנתק
          </button>
        </div>

        <div className="bg-gray-800 rounded-xl p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold text-white">רשימת הזמנות</h2>
            <button
              onClick={fetchOrders}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
              disabled={loading}
            >
              {loading ? 'טוען...' : 'רענן'}
            </button>
          </div>

          {error && (
            <div className="bg-red-900/20 border border-red-600/30 rounded-lg p-4 mb-4">
              <p className="text-red-400">{error}</p>
            </div>
          )}

          {orders.length === 0 ? (
            <div className="text-center py-8 text-gray-400">
              {loading ? 'טוען הזמנות...' : 'אין הזמנות עדיין'}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-300 min-w-[1400px]">
                <thead className="text-xs text-gray-400 uppercase bg-gray-700">
                  <tr>
                    <th className="px-4 py-3 min-w-[120px]">שם מלא</th>
                    <th className="px-4 py-3 min-w-[180px]">אימייל</th>
                    <th className="px-4 py-3 min-w-[120px]">טלפון</th>
                    <th className="px-4 py-3 min-w-[60px]">גיל</th>
                    <th className="px-4 py-3 min-w-[80px]">מגדר</th>
                    <th className="px-4 py-3 min-w-[120px]">מיקום</th>
                    <th className="px-4 py-3 min-w-[100px]">זמן ריצה</th>
                    <th className="px-4 py-3 min-w-[80px]">מתח</th>
                    <th className="px-4 py-3 min-w-[80px]">מקבילים</th>
                    <th className="px-4 py-3 min-w-[100px]">קטגוריה</th>
                    <th className="px-4 py-3 min-w-[120px]">סטטוס</th>
                    <th className="px-4 py-3 min-w-[150px]">תאריך ושעה</th>
                    <th className="px-4 py-3 min-w-[100px]">פעולות</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order, index) => (
                    <tr key={index} className="bg-gray-800 border-b border-gray-700">
                      <td className="px-4 py-4 min-w-[120px]">{order.userData?.fullName || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[180px]">{order.userData?.email || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[120px]">{order.userData?.phone || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[60px]">{order.userData?.age || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[80px]">{order.userData?.gender || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[120px]">{order.userData?.location || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[100px]">{order.userData?.oneKmTime || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[80px]">{order.userData?.pullUps || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[80px]">{order.userData?.dips || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[100px]">{order.program?.category || 'לא זמין'}</td>
                      <td className="px-4 py-4 min-w-[120px]">
                        <span className={`px-2 py-1 rounded text-xs ${
                          order.status === 'pending_payment' 
                            ? 'bg-yellow-600 text-yellow-100' 
                            : 'bg-green-600 text-green-100'
                        }`}>
                          {order.status === 'pending_payment' ? 'ממתין לתשלום' : 'שולם'}
                        </span>
                      </td>
                      <td className="px-4 py-4 min-w-[150px]">{formatDate(order.timestamp)}</td>
                      <td className="px-4 py-4 min-w-[100px]">
                        <button
                          onClick={() => setSelectedOrder(order)}
                          className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-xs rounded"
                        >
                          פרטים
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal for order details */}
      {selectedOrder && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-gray-800 rounded-xl p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-bold text-white">פרטי הזמנה מלאים</h3>
              <button
                onClick={() => setSelectedOrder(null)}
                className="text-gray-400 hover:text-white text-2xl"
              >
                ×
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* פרטי משתמש */}
              <div className="bg-gray-700 rounded-lg p-4">
                <h4 className="text-lg font-bold text-green-400 mb-4">פרטי המשתמש</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>שם מלא:</strong> {selectedOrder.userData?.fullName}</p>
                  <p><strong>אימייל:</strong> {selectedOrder.userData?.email}</p>
                  <p><strong>טלפון:</strong> {selectedOrder.userData?.phone}</p>
                  <p><strong>גיל:</strong> {selectedOrder.userData?.age}</p>
                  <p><strong>מגדר:</strong> {selectedOrder.userData?.gender}</p>
                  <p><strong>מיקום:</strong> {selectedOrder.userData?.location}</p>
                  <p><strong>בריא/ה:</strong> {selectedOrder.userData?.healthy ? 'כן' : 'לא'}</p>
                </div>
              </div>

              {/* פרטי כושר */}
              <div className="bg-gray-700 rounded-lg p-4">
                <h4 className="text-lg font-bold text-green-400 mb-4">מדדי כושר</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>זמן ריצה 1 ק"מ:</strong> {selectedOrder.userData?.oneKmTime}</p>
                  <p><strong>זמן ריצה בשניות:</strong> {selectedOrder.userData?.runTime}</p>
                  <p><strong>מתח:</strong> {selectedOrder.userData?.pullUps}</p>
                  <p><strong>מקבילים:</strong> {selectedOrder.userData?.dips}</p>
                </div>
              </div>

              {/* פרטי תוכנית */}
              <div className="bg-gray-700 rounded-lg p-4">
                <h4 className="text-lg font-bold text-green-400 mb-4">תוכנית אימונים</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>קטגוריה:</strong> {selectedOrder.program?.category}</p>
                  <p><strong>משך התוכנית:</strong> {selectedOrder.program?.category === 'קשה' ? 'חודש' : 'שבועיים'}</p>
                </div>
              </div>

              {/* פרטי הזמנה */}
              <div className="bg-gray-700 rounded-lg p-4">
                <h4 className="text-lg font-bold text-green-400 mb-4">פרטי הזמנה</h4>
                <div className="space-y-2 text-sm">
                  <p><strong>סטטוס:</strong> 
                    <span className={`ml-2 px-2 py-1 rounded text-xs ${
                      selectedOrder.status === 'pending_payment' 
                        ? 'bg-yellow-600 text-yellow-100' 
                        : 'bg-green-600 text-green-100'
                    }`}>
                      {selectedOrder.status === 'pending_payment' ? 'ממתין לתשלום' : 'שולם'}
                    </span>
                  </p>
                  <p><strong>שיטת תשלום:</strong> {selectedOrder.paymentMethod}</p>
                  <p><strong>סכום:</strong> {selectedOrder.amount} {selectedOrder.currency}</p>
                  <p><strong>תאריך הזמנה:</strong> {formatDate(selectedOrder.timestamp)}</p>
                  <p><strong>מזהה הזמנה:</strong> {selectedOrder.id}</p>
                </div>
              </div>
            </div>

            {/* תוכנית אימונים מלאה */}
            {selectedOrder.program?.plan && (
              <div className="mt-6 bg-gray-700 rounded-lg p-4">
                <h4 className="text-lg font-bold text-green-400 mb-4">תוכנית אימונים מלאה</h4>
                <div className="bg-gray-800 rounded p-4 max-h-96 overflow-y-auto">
                  <pre className="text-sm text-gray-300 whitespace-pre-wrap font-mono">
                    {selectedOrder.program.plan}
                  </pre>
                </div>
              </div>
            )}

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setSelectedOrder(null)}
                className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg"
              >
                סגור
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
